import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { TranslatePipe } from '@ngx-translate/core'
import { filter } from 'rxjs/operators'
import { BaseModule } from 'shared/base/base.module'
import { environment } from '../../../environments/environment'
import { HubtypeUser } from '../../models/hubtype-user'
import * as fromRoot from '../../reducers'
import { SharedComponentModule } from '../../shared/shared-components.module'
import { LoginFormComponent } from './login-form/login-form.component'

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  imports: [
    LoginFormComponent,
    BaseModule,
    SharedComponentModule,
    TranslatePipe,
  ],
})
export class LoginComponent implements OnInit {
  public error: string
  public ssoUrl: string = environment.ssoUrl

  private returnUrl: string
  private destroyRef = inject(DestroyRef)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromRoot.State>
  ) {}

  ngOnInit() {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        this.error = params['error']
      })
    this.returnUrl = this.route.snapshot.queryParams['returnUrl']
    this.store
      .select(fromRoot.getMeState)
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe((me: HubtypeUser) => {
        if (me && !me.must_change_password) {
          if (this.returnUrl) {
            this.router.navigateByUrl(this.returnUrl)
          } else {
            const url = `/${me.preferred_product || 'desk'}`
            this.router.navigate([url])
          }
        } else {
          this.router.navigate(['/auth/reset-password'])
        }
      })
  }
}
